import { render, staticRenderFns } from "./Product.html?vue&type=template&id=1617b6e4&scoped=true&"
import script from "./Product.ts?vue&type=script&lang=ts&"
export * from "./Product.ts?vue&type=script&lang=ts&"
import style0 from "./Product.css?vue&type=style&index=0&id=1617b6e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1617b6e4",
  null
  
)

export default component.exports